import React, { Fragment, useState } from 'react';
import Button from 'react-bootstrap-button-loader';
import Permisos from './permisos';
import { buildPermisosMap, getAllPermisosKeys, getDefaultPermisosByTipo } from './permisos.config';
import notie from 'notie';
import '../../assets/css/notie.css';
import { useUserPermisos } from '../hooks/useUserPermisos';

const crearPermisos = (tipo = 'Limitado') => getDefaultPermisosByTipo(tipo);

const seleccionarTodosPermisos = () => buildPermisosMap(getAllPermisosKeys());

const AgregarUsuario = ({ setPag_agregar, onUsuarioGuardado }) => {
  const { usuario: usuarioActual } = useUserPermisos();
  const esSuperAdminActual = usuarioActual?.tipo_usuario === 3;
  const puedeConfigurarPermisos = esSuperAdminActual;

  const tipoInicial = 'Limitado';
  const [form, setForm] = useState({
    nombres: '',
    apellidos: '',
    correo: '',
    telefono: '',
    tipo: tipoInicial
  });

  const [permisos, setPermisos] = useState(crearPermisos(tipoInicial));
  const [loading, setLoading] = useState(false);

  const onChange = e => {
    const { name, value } = e.target;
    if (name === 'tipo') {
      if (esSuperAdminActual) {
        setForm(prev => ({ ...prev, tipo: value }));
        setPermisos(crearPermisos(value));
      }
      return;
    }
    setForm(prev => ({ ...prev, [name]: value }));
  };

  const handleSelectAll = (isChecked) => {
      if (isChecked) {
          setPermisos(seleccionarTodosPermisos());
      } else {
          setPermisos(crearPermisos(form.tipo));
      }
  };

  const guardar = () => {
    if (!form.nombres || !form.correo) {
        alert('Nombre y correo son obligatorios');
        return;
    }

    setLoading(true);

    fetch('/p_usuarios', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ ...form, permisos })
    })
      .then(res => res.json())
      .then(res => {
        setLoading(false);
        if (res && res.estado === 1) {
            const password = res?.resultado?.contrasena;
            if (password) {
                console.log('Contrase?a generada para el usuario:', password);
            }
            notie.alert({ type: 'success', text: 'Usuario creado correctamente', time: 2 });
            if (typeof onUsuarioGuardado === 'function') {
                onUsuarioGuardado();
            } else {
                setPag_agregar(false);
            }
        } else {
            alert(res?.resultado || 'No se pudo guardar el usuario');
        }
      })
      .catch(error => {
          console.error("Error al guardar:", error);
          alert('Ocurrió un error al guardar');
          setLoading(false);
      });
  };

  return (
    <Fragment>

      <div className="container-fluid">
        <div className="card">
          <div className="card-body">
            
            <button 
              className="btn btn-outline-light-2x txt-dark mb-4"
              onClick={() => setPag_agregar(false)} 
            >
                <i className="icofont icofont-arrow-left"/>Regresar
            </button>
            
            <div className="row">
              <div className="col-12 pb-4">
                <h4><strong>Agregar Usuario</strong></h4>
              </div>

              <div className="col-md-6">
                <label>Nombres</label>
                <input className="form-control" name="nombres" onChange={onChange} value={form.nombres} />
              </div>

              <div className="col-md-6">
                <label>Apellidos</label>
                <input className="form-control" name="apellidos" onChange={onChange} value={form.apellidos} />
              </div>

              <div className="col-md-6 mt-3">
                <label>Correo</label>
                <input className="form-control" name="correo" onChange={onChange} value={form.correo} />
              </div>

              <div className="col-md-6 mt-3">
                <label>Teléfono</label>
                <input className="form-control" name="telefono" onChange={onChange} value={form.telefono} />
              </div>

              <div className="col-md-6 mt-3">
                <label>Tipo Usuario</label>
                <select
                  className="form-control"
                  name="tipo"
                  onChange={onChange}
                  value={form.tipo}
                  disabled={!esSuperAdminActual}
                >
                  <option value="Administrador">Administrador</option>
                  <option value="Limitado">Limitado</option>
                  {esSuperAdminActual && (
                    <option value="SuperAdministrador">Super Administrador</option>
                  )}
                </select>
              </div>
            </div>

            <div className="d-flex justify-content-end mt-4">
           

              <Button className="btn btn-success" onClick={guardar} loading={loading}>
                Guardar Usuario
              </Button>
            </div>

            {puedeConfigurarPermisos && (
              <>
                <hr />

                <Permisos 
                    permisos={permisos} 
                    onChange={setPermisos} 
                    onSelectAll={handleSelectAll} 
                />

                <div className="d-flex justify-content-end mt-4">
                  <Button className="btn btn-success" onClick={guardar} loading={loading}>
                    Guardar Permisos
                  </Button>
                </div>
              </>
            )}

          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default AgregarUsuario;
